import UIModal from 'components/lib/modal/UIModal';
import { FC, useEffect } from 'react';
import BrandSelection from './BrandSelection';
import { Box, Paper } from '@mui/material';
import classes from './BrandSelection.module.scss';
type BrandSelectionModalProps = {};
const BrandSelectionModal: FC<BrandSelectionModalProps> = ({}) => {
  const _onModalClose = () => {};
  useEffect(() => {
    console.log('Mounted BrandSelectionModal');
  }, []);
  return (
    <UIModal title="" message="" onConfirm={_onModalClose} show={true} closable={false}>
      {/* <Paper className={classes.main}> */}
      <BrandSelection />
      {/* </Paper> */}
    </UIModal>
  );
};

export default BrandSelectionModal;
